<template>
    <div class="content-box bg-white-like give-review">
        <h2 class="h3 mb-3">Donnez votre avis</h2>

        <div class="d-flex flex-column flex-md-row align-items-center give-review-container">
            <a :href="poi.link" :title="poi.name">
                <img :src="poi.picture" alt="photo du lieu" class="image-like reviewed-place-image" :alt="poi.name">
            </a>

            <div class="d-flex flex-column mx-3 mt-3 mb-4 mb-md-3 reviewed-place-info">
                <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
                    <a :href="poi.link" class="reviewed-place-name mb-2 mb-md-0" :title="poi.name">{{ poi.name }}</a>

                    <div class="d-flex align-items-center">
                        <p class="me-2 mb-0 reviews-number">{{ poi.reviewsCount }} avis</p>
                        <div class="review-content-stars">
                            <div class="review-content-stars-mark" :style="'width:' + poi.average*20 +'%'">
                                <img src="/images/star-system--small.png" :alt="poi.average +'/5'">
                            </div>
                        </div>
                    </div>
                </div>

                <p class="reviewed-place-city mt-0">{{ poi.city_name }}</p>

                <a :href="poi.link + '#writeReview'" :title="poi.name">
                    <img src="/images/avis/clique-avis.png" alt="" class="image-click">
                </a>
            </div>
        </div>

        <span class="link-like link-arrow mt-2" @click="changePoi">Montrez-moi un autre lieu</span>
    </div>
</template>

<script>
export default {
    props: {
        userId: String
    },

    data() {
        return {
            poi: null
        }
    },

    mounted() {
        this.changePoi();
    },

    methods: {
        changePoi() {
            if (this.ajaxReq) {
                this.ajaxReq.cancel('stop');
            }

            this.ajaxReq = axios.CancelToken.source();

            axios.post('/api/v1/proposal-poi?id=' + this.userId, {
                cancelToken: this.ajaxReq.token
            }).then((response) => {
                this.poi = response.data;
            }).catch((error) => {
                if (axios.isCancel(error)) {
                    return "axios request cancelled";
                }

                return error;
            });
        }
    }
};
</script>
